module.exports = __webpack_public_path__ + "img/Error.df886802.svg";